import request from "@/service";

/* 查询考核规则列表 */
export function creditRuleList(data) {
  return request({
    url: `/user/credit/rule/page`,
    method: "get",
    params: data
  });
}

/* 查询该学分规则明细 */
export function creditRuleInfo(uuid) {
  return request({
    url: `/user/credit/rule/info/${uuid}`,
    method: "get"
  });
}

/* 新增学分规则 */
export function creditRuleSave(data) {
  return request({
    url: `/user/credit/rule/save`,
    method: "post",
    data
  });
}

/* 编辑学分规则明细信息 */
export function creditRuleUpdate(data) {
  return request({
    url: `/user/credit/rule/update`,
    method: "put",
    data
  });
}

/* 学分规则启用停用 */
export function creditRuleDisplay(status, uuid) {
  return request({
    url: `/user/credit/rule/display/${status}/${uuid}`,
    method: "get"
  });
}

/* 批量删除学分规则 */
export function creditRuleDelete(data) {
  return request({
    url: `/user/credit/rule/delete`,
    method: "delete",
    data
  });
}



export function creditRuleListNew(data) {
  return request({
    url: `/user/credit/rule/list`,
    method: "get",
    params: data
  });
}


export function creditRuleInfoNew(data) {
  return request({
    url: `/user/credit/rule/infoNew`,
    method: "post",
    data
  });
}

export function creditRuleSaveNew(data) {
  return request({
    url: `/user/credit/rule/saveNew`,
    method: "post",
    data
  });
}

/* 编辑学分规则明细信息 */
export function creditRuleUpdateNew(data) {
  return request({
    url: `/user/credit/rule/updateNew`,
    method: "put",
    data
  });
}

/* 学分规则启用停用 */
export function creditRuleDisplayNew(data) {
  return request({
    url: `/user/credit/rule/displayNew`,
    method: "post",
    data,
  });
}

/* 批量删除学分规则 */
export function creditRuleDeleteNew(data) {
  return request({
    url: `/user/credit/rule/deleteNew`,
    method: "post",
    data
  });
}
